import i18n from './config';
import { useTranslation } from 'react-i18next';

/** Literal UI copy only. Never use this to translate user-entered data or stored enums. */
export function uiText(text: string, values?: Record<string, unknown>): string {
  return i18n.t(text, { ...values, ns: 'interface', keySeparator: false, nsSeparator: false, defaultValue: text }) as string;
}

export function useUiLanguage() {
  useTranslation('interface');
}

export function currentLocale(): string {
  return i18n.resolvedLanguage || i18n.language || 'en';
}

const statusLabels: Record<string, string> = {
  pending: 'Pending', partial: 'Partial', complete: 'Complete', paid: 'Paid', overdue: 'Overdue',
  cancelled: 'Cancelled', canceled: 'Cancelled', active: 'Active', inactive: 'Inactive',
  admin: 'Administrator', student: 'Student', super_user: 'Super administrator',
  open: 'Open', in_progress: 'In progress', resolved: 'Resolved', closed: 'Closed',
  completed: 'Completed', upcoming: 'Upcoming', ongoing: 'Ongoing', income: 'Income', expense: 'Expense',
};
export function statusText(value: string): string {
  return statusLabels[value] ? uiText(statusLabels[value]) : value;
}
